import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'equal', 'IconEqual', [["path",{"d":"M5 10h14","key":"svg-0"}],["path",{"d":"M5 14h14","key":"svg-1"}]]);